<template>
  <v-layout row wrap pt-2>
    <v-flex shrink pr-0>
      <v-subheader class="pl-0">{{ label }}</v-subheader>
    </v-flex>
    <v-flex pr-3>
      <v-slider
        @input="(val) => $emit('input', val)"
        :value="value"
        v-bind="$attrs"
        thumb-label="always"
        step="1"
        ticks="always"
        tick-size="2"
        hide-details
      ></v-slider>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  inheritAttrs: false,
  props: ['value', 'label'],
  data: () => ({}),
  methods: {},
}
</script>
